class VideoRecorder {
  constructor(stream, dataListener) {
    this.isRecording = false
    this.recordings = []
    this.dataListener = dataListener
    let mimeType = ''
    this.contentType = 'video/webm'
    if (MediaRecorder.isTypeSupported('video/webm; codecs=vp9')) {
      mimeType = 'video/webm; codecs=vp9'
    } else if (MediaRecorder.isTypeSupported('video/webm; codecs=vp8')) {
      mimeType = 'video/webm; codecs=vp8'
    } else {
      mimeType = 'video/mp4; codecs="avc1.42E01E"'
      this.contentType = 'video/mp4'
    }
    this.recorder = new MediaRecorder(stream, {
      mimeType,
      /** Aligns with iOS / mobile -- 800Kbps */
      videoBitsPerSecond: 800000
    })

    this.recorder.addEventListener('dataavailable', e => this.handleData(e))
    this.currentSnippetId = undefined
  }

  // snippetId lets us differentiate the clips
  // currently optional, maybe default to a UUID?
  // suggested use: trial id, for example
  record(snippetId = '') {
    if (this.isRecording) {
      throw new Error('Already Recording')
    }
    this.currentSnippetId = snippetId
    this.recorder.start()
    this.isRecording = true
  }

  stop() {
    if (!this.isRecording) {
      throw new Error('Not Recording')
    }
    this.recorder.stop()
    this.isRecording = false
  }

  handleData(e) {
    if (e.data?.size > 0) {
      this.recordings.push({
        snippetId: this.currentSnippetId,
        clip: e.data,
        contentType: this.contentType
      })

      this.dataListener?.(this.getWithDownloadUrls())
    }
  }

  getRecordings() {
    return this.recordings
  }

  getWithDownloadUrls() {
    return this.recordings.map(({ clip, snippetId, contentType }) => {
      const url = URL.createObjectURL(clip)
      return {
        snippetId, url, clip, contentType
      }
    })
  }

  getStitchedClips() {
    const { contentType } = this
    const blob = new Blob(this.recordings, {
      type: contentType
    })
    const url = URL.createObjectURL(blob)
    return { url, blob, contentType }
  }
}

export default VideoRecorder
